import React, { useState } from 'react';
import { columns as templateColumns } from './columns';
import PropTypes from 'prop-types';
import TemplateTasks from './Layouts/index';
import TemplateDetails from './Layouts/details';
import Form from './form';
import { filters } from './filters';
// import Operation from './Operation';
import { connect, useSelector } from 'react-redux';
import Operation from './operational';
import { actions as dataGridTableActions } from './Modules/dataGridTable';

const Template = ({ fetchTaskTemplates }) => {
  const [formProps, setFormProps] = useState({});
  //selectors
  const loading = useSelector(state => state.ui.loading);

  const Operational = props => {
    return (
      <Operation
        {...props}
        setFormProps={setFormProps}
        canCopyTemplate={false}
      />
    );
  };
  const fetchTaskList = ({ filters, from }) => {
    fetchTaskTemplates({
      filters,
      from,
    });
  };

  return (
    <TemplateTasks
      customFetchTaskList={fetchTaskList}
      editable
      cols={templateColumns}
      downloadable={false}
      DetailComponent={TemplateDetails}
      operationComponent={Operational}
      loading={loading}
      filters={filters}
      FormComponent={props => (
        <Form {...props} {...formProps} setFormProps={setFormProps} />
      )}
    />
  );
};
Template.propTypes = {
  downloadable: PropTypes.bool,
  fetchTaskTemplates: PropTypes.func,
  defaultFilterValues: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
  fetchTaskTemplates: ({ filters, from }) =>
    dispatch(dataGridTableActions.fetchGridList({ filters, from })),
});

export default connect(null, mapDispatchToProps)(Template);
